import React from "react"
import "../styles/styles.scss"


// Import Components
import Header from "../components/header"
import Banner from "../components/banner"
import Footer from "../components/footer"

const IndexPage = () => (
  <div>
    <Header />
    <Banner />
    <Footer />
  </div>
)

export default IndexPage
